import React, { useRef, useState, useEffect } from 'react'
import './App.css';
import Box from './components/Box'
import Countdown from 'react-countdown';
import Typewriter from 'typewriter-effect';
import { CSSTransition } from 'react-transition-group'
import { ReactComponent as Bubble1 } from './images/bubble1.svg'
import { ReactComponent as Bubble2 } from './images/bubble2.svg'

const renderer = ({ seconds }) => {
  return (
    <span>{seconds}</span>
  )
}

function App() {
  const [number1, setNumber1] = useState(null)
  const [number2, setNumber2] = useState(null)
  const [counter, setCounter] = useState(0)
  const [countdownKey, setCountdownKey] = useState(1)
  const [skip, setSkip] = useState(false)
  const [enter, setEnter] = useState(false)
  const [timer, setTimer] = useState(3)
  const [status, setStatus] = useState('pending')
  const [result, setResult] = useState('')
  const [warning, setWarning] = useState(false)
  const [showButton, setShowButton] = useState(false)
  const [computerNumber, setComputerNumber] = useState(null)
  const [playerNumber, setPlayerNumber] = useState(null)
  const numberBank = useRef([])
  const playerScore = useRef([])
  const computerScore = useRef([])
  const timeOut = useRef()
  const min = useRef(null);
  const max = useRef(null)
  const countdown = useRef(null);

  useEffect(() => {
    console.log(counter)
    if (counter > 0) {
      timeOut.current = setTimeout(() => setCounter(counter - 1), 1000)
    } else if (counter === 0 && status === 'playing') {
      roundCheck()
    }
  }, [counter]);

  const onStart = () => {
    //check settings
    if (number1 !== null && number2 !== null && timer !== null) {
      let numberOne = Number(number1)
      let numberTwo = Number(number2)
      if (numberOne > numberTwo) {
        max.current = numberOne
        min.current = numberTwo
      } else if (numberTwo > numberOne) {
        max.current = numberTwo;
        min.current = numberOne;
      } else if (numberTwo === numberOne) {
        max.current = numberOne
        min.current = numberTwo
      }

      console.log('max', max.current)
      console.log('min', min.current)
      for (let i = min.current; i <= max.current; i++) {
        numberBank.current.push(Number(i));
      }
      setWarning(false)
      setCounter(timer)
      setStatus('playing')
    } else {
      setWarning(true)
    }
  }

  const computerChoose = () => {
    let newNumberBank = numberBank.current.slice()
    let chooseNumber
    const random = Math.floor(Math.random() * newNumberBank.length);
    chooseNumber = newNumberBank.splice(random, 1)
    numberBank.current = newNumberBank
    computerScore.current.push(chooseNumber[0])
    setComputerNumber(chooseNumber[0])
    if (numberBank.current.length === 0) {
      //finish
      finish();
      setStatus('finish')
      return
    }
  }

  const roundCheck = () => {
    console.log('player number', playerNumber)
    let playerChooseIndex = numberBank.current.indexOf(Number(playerNumber))
    if (playerNumber === null) {
      //not fill
    } else if (playerChooseIndex !== -1) {
      //has number
      let newNumberBank = numberBank.current.slice()
      let chooseNumber = newNumberBank.splice(playerChooseIndex, 1)
      numberBank.current = newNumberBank
      playerScore.current.push(chooseNumber[0])
    } else if (playerChooseIndex === -1) {
      //dont have number
    }

    if (numberBank.current.length === 0) {
      //finish
      finish();
      setStatus('finish')
      return
    }
    setPlayerNumber('')
    computerChoose();
    setCounter(timer)
  }

  const resetCountdown = () => {
    setCountdownKey(countdown + 1)
  }

  const finish = () => {
    // console.log('player score count',playerScore.length)
    // console.log('computer score count', computerScore.length)
    if (playerScore.current.length > computerScore.current.length) {
      setResult('WIN')
    } else if (playerScore.current.length < computerScore.current.length) {
      setResult('LOSE')
    } else if (playerScore.current.length === computerScore.current.length) {
      setResult('DRAW')
    }
  }

  const startCountdown = () => {
    countdown.current.start();
  }

  const printAll = () => {
    console.log('number bank', numberBank.current)
    console.log('player score', playerScore.current)
    console.log('computer score', computerScore.current)
  }

  const initSkip = () => {
    setSkip(true)
  }

  const submitHandler = (e) => {
    e.preventDefault();
    clearTimeout(timeOut.current);
    setEnter(enter)
    roundCheck();
  }

  return (
    <div className="App">
      <div className="boxContainer">
        <Box
          className="box"
        />
        <div className="gameSettingsContainer">
          <span className="gameSettings">Number: <input className="settingInput" type="number" name="number1" value={number1} onChange={(e) => setNumber1(e.target.value)}></input>to<input className="settingInput" type="number" name="number2" value={number2} onChange={(e) => setNumber2(e.target.value)}></input></span>
          <span className="gameSettings">Wait time: <input className="settingInput" type="number" name="timer" value={timer} onChange={(e) => setTimer(e.target.value)}></input></span>
        </div>
      </div>
      <div className="bubble1Container">
        {/* <Bubble1 className="bubble1" /> */}
        {status === 'playing' &&
          <React.Fragment>
            <form onSubmit={(e) => submitHandler(e)}>
              <input type="number" value={playerNumber} onChange={(e) => setPlayerNumber(e.target.value)} className="playerNumber" autoFocus></input>
            </form>
          </React.Fragment>
        }
        <div className="countdownContainer">
          <span>countdown: {counter}</span>
        </div>
      </div>
      <div className="bubble2Container">
        {/* <Bubble2 className="bubble2" /> */}
        {status === 'playing' &&
          <span className="computerNumber">{computerNumber}</span>
        }
      </div>
      {/* this button is for test only */}
      {/* <a className="button" onClick={startCountdown}>start</a>
      <a className="button" onClick={printAll}>print</a>
      <a className="button" onClick={computerChoose}>computer</a>
      <a className="button" onClick={roundCheck}>check</a> */}
      <CSSTransition
        in={status === 'pending'}
        timeout={300}
        classNames="popup"
        unmountOnExit
      >
        <div className="popupContainer" onClick={initSkip}>
          {!skip &&
            <div className="popup">
              <div className="popup__content">
                <Typewriter
                  options={{
                    delay: 50
                  }}
                  onInit={(typewriter) => {
                    typewriter.typeString('>"Play with me!" the thing says.<br><br>')
                      .pauseFor(500)
                      .typeString('>You agreed, "what we playing?"<br><br>')
                      .pauseFor(500)
                      .typeString('>"In turns, we claim one number no-repeat."')
                      .pauseFor(500)
                      .callFunction(() => {
                        setShowButton(true)
                      })
                      .start();
                  }}
                />
                <CSSTransition
                  in={showButton}
                  timeout={300}
                  classNames="fade"
                  unmountOnExit
                >
                  <div className="buttonContainer">
                    <a className="button" onClick={onStart}>
                      start
                  </a>
                    {warning &&
                      <span className="warning">The settings on the box is required</span>
                    }
                  </div>
                </CSSTransition>
              </div>
            </div>
          }
          {skip &&
            <div className="popup">
              <div className="popup__content">
                <div>
                  >"Play with me!" the thing says.<br></br><br></br>

                  >You agreed, "what we playing?"<br></br><br></br>

                  >"In turns, we claim one number no-repeat."
                </div>
                <div className="buttonContainer">
                  <a className="button" onClick={onStart}>
                    start
                          </a>
                  {warning &&
                    <span className="warning">The settings on the box is required</span>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </CSSTransition>
      <CSSTransition
        in={status === 'finish'}
        timeout={300}
        classNames="popup"
        unmountOnExit
      >
        <div className="popupContainer">
          <div className="popup">
            <div className="popup__content">
              {result === 'WIN' &&
                <h1>You win!</h1>
              }
              {result === 'LOSE' &&
                <h1>You lose!</h1>
              }
              {result === 'DRAW' &&
                <h1>It's a draw</h1>
              }
              <div>
                Computer's numbers: {computerScore.current.toString()}
              </div>
              <div>
                Your numbers: {playerScore.current.toString()}
              </div>
            </div>
          </div>
        </div>
      </CSSTransition>
    </div>
  );
}

export default App;
